import { MenuPlacement, Options } from 'react-select'
import _isNil from 'lodash/isNil'
import { StyledLabel, StyledSelect, StyledSelectLabelWrapper } from './styles'

export interface DropDownProps {
  name: string
  value?: DropdownOption
  onChange?: (newValue: any) => void
  options?: Options<DropdownOption>
  placeholder?: string
  className?: string
  isSearchable?: boolean
  isClearable?: boolean
  disabled?: boolean
  showLabel?: boolean
  menuPlacement?: MenuPlacement
}

export interface DropdownOption {
  label: string
  value: string | number | boolean | object
}

function DropDown({
  name,
  value,
  onChange,
  options,
  placeholder,
  className,
  isSearchable = false,
  isClearable = false,
  disabled = false,
  showLabel = false,
  menuPlacement = 'bottom',
}: DropDownProps) {
  return (
    <>
      {showLabel && value?.value && (
        <StyledSelectLabelWrapper>
          <StyledLabel htmlFor={name}>{placeholder}</StyledLabel>
        </StyledSelectLabelWrapper>
      )}
      <StyledSelect
        inputId={name}
        placeholder={placeholder}
        classNamePrefix="select"
        className={className}
        isSearchable={isSearchable}
        isClearable={isClearable}
        name={name}
        value={!_isNil(value?.value) ? value : null} // null is a fix for value reset, based on https://github.com/JedWatson/react-select/issues/2931
        onChange={onChange}
        isDisabled={disabled}
        options={options}
        menuPlacement={menuPlacement}
      />
    </>
  )
}

export default DropDown
